export enum policyModules {
  booking = "booking",
  bill = "bill",
  lab = "lab",
  stock = "stock",
  campaign = "campaign",
  report = "report",
  clients = "clients",
  dashboard = "dashboard",
  doctors = "doctors",
  services = "services",
  ipd = "ipd",
  clinic = "clinic",
  hmis = "hmis",
  medical = "medical",
  account = "account",
  payment = "payment",
  opd = "opd",
  payroll = "payroll",
  attendance = "attendance"
}

export enum opdPolicyActions {
  listMedical = "listOpd",
  changeSettings = "changeSettings"
}

export enum medicalPolicyActions {
  createMedical = "createMedical",
  listMedical = "listMedical",
  changeSettings = "changeSettings",
  finaliseMedical = "finaliseMedical",
  manageLabResult = "manageLabResult",
  manageVitals = "manageVitals",
  manageXrayResult = "manageXrayResult",
  manageVaccination = "manageVaccination",
  manageAssessment = "manageAssessment",
  printMedicalReport = "printMedicalReport"
}

export enum accountPolicyActions {
  listAccount = "listAccount"
}

export enum dashboardPolicyActions {
  accessStatistics = "accessStatistics",
  accessWeeklyRevenue = "accessWeeklyRevenue",
  accessBookings = "accessBookings",
  accessAppointments = "accessAppointments",
  financialKpi = "financialKpi",
  clientKpi = "clientKpi",
  sms = "smsKpi",
  labKpi = "labKpi",
  opdKpi = "opdKpi",
  stockKpi = "stockKpi"
}

export enum bookingPolicyActions {
  createSchedule = "createSchedule",
  listSchedule = "listSchedule",
  updateSchedule = "updateSchedule",
  deleteSchedule = "deleteSchedule",
  createBooking = "createBooking",
  listBooking = "listBooking",
  updateBooking = "updateBooking",
  cancelBooking = "cancelBooking",
  deleteBooking = "deleteBooking",
  viewOtherSpCalendar = "viewOtherSpCalendar"
}

export enum billPolicyActions {
  listBill = "listBill",
  createDraft = "createDraft",
  finalizeBill = "finalizeBill",
  createCreditNote = "createCreditNote",
  cancelBill = "cancelBill",
  viewHistory = "viewHistory",
  recordPayment = "recordPayment",
  printBill = "printBill",
  printBillEstimate = "printBillEstimate",
  copyBill = "copyBill",
  changeSettings = "changeSettings",
  referralAndFees = "referralAndFees",
  changeBillIssueDate = "changeBillIssueDate",
  listBillCreatedByOtherUsers = "listBillCreatedByOtherUsers"
}

export enum labPolicyActions {
  listLab = "listLab",
  createOrder = "createOrder",
  finalize = "finalize",
  approve = "approve",
  print = "print",
  cancel = "cancel",
  takeSample = "takeSample",
  batchFinalize = "batchFinalize",
  importCSV = "importCSV",
  searchLab = "searchLab",
  changeSettings = "changeSettings",
  printBarCode = "printBarCode",
  accessMasterData = "accessMasterData",
  updateMasterData = "updateMasterData"
}

export enum stockPolicyActions {
  createStockProduct = "createStockProduct",
  enterPurchaseEntry = "enterPurchaseEntry",
  finalizePurchaseEntry = "finalizePurchaseEntry",
  returnPurchaseEntry = "returnPurchaseEntry",
  editPurchaseEntry = "editPurchaseEntry",
  editProduct = "editProduct",
  importCSV = "importCSV",
  search = "search",
  expiryDiscard = "expiryDiscard",
  internalUse = "internalUse",
  internalRestock = "internalRestock",
  listStock = "listStock",
  quantityAdjustment = "quantityAdjustment",
  changeSettings = "changeSettings"
}

export enum campaignPolicyActions {
  sendMessage = "sendMessage",
  createCampaign = "createCampaign",
  editCampaign = "editCampaign",
  deleteCampaign = "deleteCampaign",
  createAudience = "createAudience",
  editAudience = "editAudience",
  deleteAudience = "deleteAudience",
  createTemplate = "createTemplate",
  editTemplate = "editTemplate",
  deleteTemplate = "deleteTemplate",
  listCampaign = "listCampaign",
  listAudience = "listAudience",
  listTemplate = "listTemplate"
}

export enum reportPolicyActions {
  patientFlowReport = "patientFlowReport",
  patientAssessmentReport = "patientAssessmentReport",
  serviceProviderChargesReport = "serviceProviderChargesReport",
  salesReport = "salesReport",
  salesByServiceReport = "salesByServiceReport",
  summaryReport = "summaryReport",
  dueReport = "dueReport",
  clientLedgerReport = "clientLedgerReport",
  ipdBillsReport = "ipdBillsReport",
  dentalLabReport = "dentalLabReport",
  hmisLabReport = "hmisLabReport",
  hmisMainReport = "hmisMainReport",
  billingPackageReport = "billingPackageReport",
  billPaymentReport = "billPaymentReport",
  receiptReport = "receiptReport",
  smsReport = "smsReport",
  labReport = "labReport",
  stockAuditReport = "stockAuditReport",
  stockCashFlowReport = "stockCashFlowReport",
  supplierLedgerReport = "supplierLedgerReport",
  accessReportMenu = "accessReportMenu",
  feesAndReferralReport = "feesAndReferralReport",
  cmsReport = "cmsReport",
  historyReport = "historyReport",
  payrollReport = "payrollReport",
  salesByServiceProviderReport = "salesByServiceProviderReport"
}

export enum clientPolicyActions {
  createClient = "createClient",
  editClient = "editClient",
  importClient = "importClient",
  searchClient = "searchClient",
  listClient = "listClient",
  listCorporateClient = "listCorporateClient",
  createCorporateClient = "createCorporateClient"
}

export enum doctorPolicyActions {
  listDoctors = "listDoctors",
  createDoctors = "createDoctors",
  editDoctors = "editDoctors",
  editPublicBookingSetting = "editPublicBookingSetting",
  editPermissionGroup = "editPermissionGroup",
  resetPassword = "resetPassword",
  deleteDoctor = "deleteDoctor"
}

export enum servicePolicyActions {
  createProduct = "createProduct",
  editProduct = "editProduct",
  deleteProduct = "deleteProduct",
  createPackage = "createPackage",
  editPackage = "editPackage",
  deletePackage = "deletePackage",
  listService = "listService",
  addPayables = "addPayables",
  importCSV = "importCSV"
}

export enum ipdPolicyActions {
  createIpd = "createIpd",
  createProgressRecord = "createProgressRecord",
  prescribeMedication = "prescribeMedication",
  createDischarge = "createDischarge",
  listIpd = "listIpd",
  ipdBill = "ipdBill",
  changeSettings = "changeSettings"
}

export enum clinicPolicyActions {
  listClinics = "listClinics",
  createResourceCentre = "createResourceCentre",
  listAdmin = "listAdmin",
  deleteAdmin = "deleteAdmin",
  editAdmin = "editAdmin",
  createAdmin = "createAdmin",
  changePermissionGroups = "changePermissionGroups",
  resetPasswords = "resetPasswords",
  deleteUsers = "deleteUsers",
  createSuppliers = "createSuppliers",
  editSuppliers = "editSuppliers",
  deleteSuppliers = "deleteSuppliers",
  listSuppliers = "listSuppliers",
  createReferrers = "createReferrers",
  editReferrers = "editReferrers",
  deleteReferrers = "deleteReferrers",
  listReferrers = "listReferrers",
  accessClinicAdminSetting = "accessClinicAdminSetting",
  accessPublicSettings = "accessPublicSettings",
  accessSettingsAndSubscriptions = "accessSettingsAndSubscriptions",
  publicBookingReport = "publicBookingReport",
  accessHolidaySetting = "accessHolidaySetting",
  accessPublicBookingSetting = "accessPublicBookingSetting"
}

export enum hmisPolicyActions {
  listHmis = "listHmis"
}

export enum paymentPolicyActions {
  listPayments = "listPayments"
}

export enum payrollPolicyActions {
  viewPayrollReport = "viewPayrollReport"
}

export enum attendancePolicyActions {
  viewAttendanceReport = "viewAttendanceReport",
  // attendance punches actions
  viewAttendancePunches = "viewAttendacePunches",
  createAttendancePunches = "createAttendancePunches",
  updateAttendancePunches = "updateAttendancePunches",
  deleteAttendancePunches = "deleteAttendancePunches",
  // leave application actions
  listLeaveApplications = "listLeaveApplications",
  createLeaveApplications = "createLeaveApplications",
  updateLeaveApplications = "updateLeaveApplications",
  deleteLeaveApplications = "deleteLeaveApplications",
  // compensatory claims actions
  listCompensatoryClaims = "listCompensatoryClaims",
  createCompensatoryClaims = "createCompensatoryClaims",
  updateCompensatoryClaims = "updateCompensatoryClaims",
  deleteCompensatoryClaims = "deleteCompensatoryClaims"
}

export type CanActions =
  | `${policyModules.booking}:${bookingPolicyActions}`
  | `${policyModules.bill}:${billPolicyActions}`
  | `${policyModules.campaign}:${campaignPolicyActions}`
  | `${policyModules.clients}:${clientPolicyActions}`
  | `${policyModules.clinic}:${clinicPolicyActions}`
  | `${policyModules.doctors}:${doctorPolicyActions}`
  | `${policyModules.ipd}:${ipdPolicyActions}`
  | `${policyModules.lab}:${labPolicyActions}`
  | `${policyModules.report}:${reportPolicyActions}`
  | `${policyModules.services}:${servicePolicyActions}`
  | `${policyModules.stock}:${stockPolicyActions}`
  | `${policyModules.hmis}:${hmisPolicyActions}`
  | `${policyModules.medical}:${medicalPolicyActions}`
  | `${policyModules.dashboard}:${dashboardPolicyActions}`
  | `${policyModules.account}:${accountPolicyActions}`
  | `${policyModules.payment}:${paymentPolicyActions}`
  | `${policyModules.opd}:${opdPolicyActions}`
  | `${policyModules.payroll}:${payrollPolicyActions}`
  | `${policyModules.attendance}:${attendancePolicyActions}`
  | { terminated: true };

export type OptActions =
  | `${policyModules.booking}:*`
  | `${policyModules.bill}:*`
  | `${policyModules.campaign}:*`
  | `${policyModules.clients}:*`
  | `${policyModules.clinic}:*`
  | `${policyModules.doctors}:*`
  | `${policyModules.ipd}:*`
  | `${policyModules.lab}:*`
  | `${policyModules.report}:*`
  | `${policyModules.services}:*`
  | `${policyModules.stock}:*`
  | `${policyModules.hmis}:*`
  | `${policyModules.medical}:*`
  | `${policyModules.dashboard}:*`
  | `${policyModules.account}:*`
  | `${policyModules.payment}:*`
  | `${policyModules.payroll}:*`
  | `${policyModules.attendance}:*`;

export enum PolicyAccessKeys {
  CmsReport = "report:cmsReport",
  DueReport = "report:dueReport",
  SalesByServiceReport = "report:salesByServiceReport",
  ReceiptReport = "report:receiptReport",
  StockAuditReport = "report:stockAuditReport"
}
